import { DocumentParameters } from 'api3';
import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation, effect, inject, signal } from '@angular/core';
import { Api3Service } from '@app/services/api3.service';
import { LoadingDotsComponent } from '@app/chat/components/loading-dots/loading-dots.component';
import { MercedesRendererComponent } from '../renderer/mercedes/mercedes-renderer.component';
import * as Sentry from '@sentry/angular';

export type MbDocument = {
  document?: string;
  svg?: { content: string };
};

@Component({
  selector: 'app-mercedes-articles',
  standalone: true,
  imports: [CommonModule, LoadingDotsComponent, MercedesRendererComponent],
  template: `
    @if (isLoading()) {
      <app-loading-dots />
    } @else {
      <app-mercedes-renderer [data]="mbDocument()" />
    }
  `,
  encapsulation: ViewEncapsulation.None,
})
export class MercedesArticlesComponent {
  @Input({ required: true }) documentParameters?: DocumentParameters;

  mbDocument = signal<MbDocument | undefined>(undefined);
  isLoading = signal(true);

  api3Service = inject(Api3Service);

  init = effect(async () => {
    if (!this.documentParameters) {
      console.warn('[MercedesArticlesComponent] DocumentParameters is undefined or missing.');
      this.isLoading.set(false);
      return;
    }

    const { data, error }: { data?: MbDocument; error?: any } = await this.api3Service.api.rmi.getMbDocuments({
      type: this.documentParameters.type,
      carTypeId: this.documentParameters.carTypeId,
      carTypeGroup: this.documentParameters.carTypeGroup,
      location: this.documentParameters.location,
      storyId: this.documentParameters.storyId,
      tsbType: this.documentParameters.tsbType,
      systemId: this.documentParameters.systemId,
      errorCode: this.documentParameters.errorCode,
      mbId: this.documentParameters.mbId,
      mbNumber: this.documentParameters.mbNumber,
      mbInfoTypeCode: this.documentParameters.mbInfoTypeCode,
      daily: this.documentParameters.daily,
    });

    if (error) {
      console.error('[MercedesArticlesComponent] Getting Mercedes HTML failed', error);

      Sentry.captureException(error, {
        tags: {
          location: 'MercedesArticlesComponent',
          feature: 'ArticleView',
          message: 'Failed to load article HTML.',
        },
      });
    }

    this.mbDocument.set(data);
    this.isLoading.set(false);
  });
}
